// Constants for Learning Plans module

export const INITIAL_PAGE_SIZE = 20;

export const DEFAULT_COLUMNS = [
  {
    name: 'learningPlan',
    displayName: 'Learning Plan',
    sortOrder: 'none',
    isFilterable: true,
    isSortable: true,
    isVisible: true,
    type: 'override',
    sortByProp: 'name',
  },
  {
    name: 'status',
    displayName: 'Status',
    sortOrder: 'none',
    isFilterable: true,
    isSortable: true,
    isVisible: true,
    type: 'override',
  },
  {
    name: 'pillars',
    displayName: 'Pillars',
    sortOrder: 'none',
    isFilterable: true,
    isSortable: true,
    isVisible: true,
    type: 'value',
  },
  {
    name: 'actions',
    displayName: 'Actions',
    sortOrder: 'none',
    isFilterable: false,
    isSortable: false,
    isVisible: true,
    type: 'override',
  }
];


